import { makeAutoObservable, runInAction } from 'mobx';
import { IFloor, IFloorParams } from 'src/@types/Choqorak/Settings/Floor';
import agent from 'src/api/agent';
export default class FloorStore {
  openDialog = false;

  FloorRegistry = new Map<number, IFloor>();

  editMode = false; //When click on edit button

  selectedFloor: IFloor | undefined = undefined;

  totalRecord: number = 0;

  selectedFloorDetail: IFloor | undefined;

  ID: any = localStorage.getItem('id');

  constructor() {
    makeAutoObservable(this);
  }

  get FloorList() {
    return Array.from(this.FloorRegistry.values());
  }

  setFloorList = (Floor: IFloor) => {
    this.FloorRegistry.set(Floor.floorId!, Floor);
  };

  //Pagination
  loadFloor = async (params: IFloorParams) => {
    // this.FloorRegistry.clear();
    try {
      const result = await agent.Floor.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setFloorList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  FloorSearch = async (params: IFloorParams) => {
    this.FloorRegistry.clear();
    this.loadFloor(params);
  };

  getFloorFromRegistry = (id: number) => {
    let Floor = this.FloorRegistry.get(id);
    if (Floor) {
      this.editMode = true;
      this.selectedFloor = Floor;
    }
  };

  clearSelectedFloor = () => {
    this.editMode = false;
    this.selectedFloor = undefined;
    this.selectedFloorDetail = undefined;
  };

  deleteFloor = async (id: number, remark?: string) => {
    await agent.Floor.delete(id, remark!);
    runInAction(() => {
      this.FloorRegistry.delete(id);
      this.totalRecord--;
      this.setOpenCloseDialog();
    });
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createFloor = async (Floor: IFloor) => {
    await agent.Floor.create(Floor, Floor.floorMap!);
    runInAction(() => {
      this.loadFloor({ pageIndex: 0, pageSize: 5 });
      this.clearSelectedFloor();
    });
  };

  updateFloor = async (Floor: IFloor) => {
    await agent.Floor.update(Floor, Floor.floorMap);

    runInAction(() => {
      this.loadFloor({ pageIndex: 0, pageSize: 5 });
      this.FloorRegistry.delete(Floor.floorId!);
      this.FloorRegistry.set(Floor.floorId!, Floor);
      this.clearSelectedFloor();
    });
  };

  loadFloorDetail = async (id: number) => {
    try {
      const getFloorDetail = await agent.Floor.getDetail(id);
      runInAction(() => {
        this.selectedFloorDetail = getFloorDetail;
      });
    } catch (error) {}
  };
}
